export default __webpack_public_path__ + "static/media/Statistic_HE_2012-2013.a62367ac.pdf";